export const environment = {
  production: false,
  enableSW: true,
  datadogRum: {
    enabled: true,
    applicationId: '0e72834e-92a0-4e2c-9854-723c73b9c4d5',
    clientToken: 'pub7ba64e3643a5b5d5bebd193108c17c28',
    site: 'datadoghq.com',
    service: 'sandbox.app.mandae.com.br',
    env: 'staging',
    sessionSampleRate: 20,
    sessionReplaySampleRate: 20,
  },
  angularJSconstants: {
    ENV: "hml",
    API_TOKEN: "PkYi89Ess",
    VERSION: "4.0.147-7309ba8",
    URL: "https://sandbox.mandae.com.br",
    URL_SITE: "https://sandbox.mandae.com.br",
    URLADMINV3: "https://webapp-hml.api.mandae.com.br/v1/admin-app",
    URLAPI: "https://sandbox.api.mandae.com.br",
    URLAPIPEDIDO: "https://webapp-hml.api.mandae.com.br/v1/pedido-services",
    URLAPICORREIOS: "https://webapp-hml.api.mandae.com.br/v1/correios-services",
    URLAPIPEDIDO_REPLICA:
      "https://webapp-hml.api.mandae.com.br/v1/encomenda-services",
    URLAPICLIENTE: "https://webapp-hml.api.mandae.com.br/v1/cliente-services",
    URLAPILOGIN: "https://login-hml.api.mandae.com.br/v1",
    URLAPIOCORRENCIA:
      "https://webapp-hml.api.mandae.com.br/v1/ocorrencia-services",
    URLAPIDIVERGENCIA:
      "https://webapp-hml.api.mandae.com.br/v1/ocorrencia-services",
    URLAPICONFERENCIA:
      "https://webapp-hml.api.mandae.com.br/v1/conferencia-services",
    URLAPICLIENTE_ETIQUETA: "https://webapp-hml.api.mandae.com.br/v1/etiqueta-services",
    URLAPIDESTINATARIO:
      "https://k8s-eks-hml.mandae.com.br/destinatario-services-hml",
    URL_FATURA_API:
      "https://5qe29qa86k.execute-api.us-east-1.amazonaws.com/hml",
    URLAPICOLETA: "https://webapp-hml.api.mandae.com.br/v1/coleta-services",
    PATH: "/lp/server/api/site/v1",
    PATH_V2: "/lp/server/api/site/v2",
    PUBLIC_API: "https://webapp-hml.api.mandae.com.br/v1/plataforma-services",
    URL_PAYPAL: "http://localhost:4200/api/paypal",
    URL_FINANCEIRO: "https://webapp-hml.api.mandae.com.br/financeiro",
    URL_PROCEDA: "https://webapp-hml.api.mandae.com.br/v1/edi-proceda-services",
    URL_RASTREAE: "https://rastreae-hml.mandae.com.br/",
    URL_RASTREAMENTO:
      "https://webapp-hml.api.mandae.com.br/v1/rastreamento-services/v2",
    URL_RELATORIOS: "https://webapp-hml.api.mandae.com.br/v1/relatorio-services",
    URL_API_NFE: "https://webapp-hml.api.mandae.com.br/financeiro",
    URL_API_ATENDIMENTO:
      "https://webapp-hml.api.mandae.com.br/v1/atendimento-services",
    URL_SERVICO_FISCAL:
      "https://webapp-hml.api.mandae.com.br/financeiro",
    PUBLIC_API_LUCENE: 'https://sandbox.api.mandae.com.br',
    TRACKSALE_KEY: "e208a8b1e06710dd",
    TRACKSALE_CAMPAIGN: "4fe82219",
    URL_SHIPPING_LABEL: "https://sandbox.madmax.mandae.com.br",
    NEW_URL_API_DOCUMENTS: 'https://webapp-hml.api.mandae.com.br/financeiro',
  },
  returnShippingApi: "https://webapp-hml.api.mandae.com.br/v1/devolucao-services",
  screeningApi: "https://webapp-hml.api.mandae.com.br/v1/etiqueta-services",
  googleMapsApiKey: "AIzaSyDYCVhvmIk5FSFHLY7VI6SdM3QRohyoS9o",
  // Login pelo Keycloak (Authorization Code + PKCE). Os valores vem das repository variables
  // KEYCLOAK_LOGIN_ENABLED/URL/REALM/CLIENT_ID_{HML,PRD}, substituidas no build pelo bitbucket-pipelines.yml.
  keycloak: {
    enabled: "true",
    url: "https://id-hml.mandae.com.br",
    realm: "mandae",
    clientId: "webapp-web",
  },
  zendesk: {
    // Master switch do ambiente: com `true`, todo cliente logado recebe o
    // Messenger; com `false`, nenhum widget. Em HML, QA pode forçar `messenger`
    // ou `off` com localStorage `zendesk_mode_override`. Ver FLAG_ZENDESK_MESSENGER.md
    messengerEnabled: true,
    // Substituída no build (pipeline) pela Repository variable ZENDESK_MESSENGER_KEY_HML.
    // Se não for substituída, a página fica sem widget.
    messengerKey: '7e075a4a-0541-4e12-b7d7-0f01660d802d',
  },
  awsWaf: {
    // CORS dos API Gateways já libera x-aws-waf-token (confirmado 2026-06-25).
    enabled: true,
    // TEMPORÁRIO: HML está usando o MESMO Web ACL de PROD para teste.
    // Quando HML ganhar Web ACL próprio, trocar por sua Integration URL.
    integrationUrl:
      "https://cb6fbba6db90.us-east-1.sdk.awswaf.com/cb6fbba6db90/2ce173dd333b/challenge.js",
    // Hosts atrás do WAF que recebem o header x-aws-waf-token. Só login: webapp-api não tem WAF.
    protectedHosts: [
      "login-hml.api.mandae.com.br",
    ],
  },
};
